import React, { Component } from 'react'
import { Modal, Button } from 'hljd'
import api from '../../api'
import { observer } from 'mobx-react'
import style from './style.module.less'
import { TEMPLATE_BLANK, WCD_ROUTE_PREVIEW } from '../../constant'
import { Flex } from 'hljd'
import cls from 'classnames'
import { goWcdPath } from '../../util'

@observer
export default class extends Component {
  state = { list: [] }
  async componentDidMount() {
    const res = await api.getTemplateList()
    const list = [
      {
        id: TEMPLATE_BLANK,
        name: '空白模板',
        coverPath: 'https://qnm.hunliji.com/FsuHoYX0kTslpF47aBVgoZ93tK5r'
      }
    ].concat(res.data || [])
    this.setState({ list })
  }

  preview = id => () => {
    goWcdPath(WCD_ROUTE_PREVIEW, id, 'type=template&pc=1')
  }

  render() {
    const { list } = this.state
    const {
      showTemplateModal,
      closeTemplateModal,
      handleCreateActivity
    } = this.props.store
    return (
      <Modal
        className={style.templateModal}
        centered
        title="选择模板 快速创建活动"
        footer={null}
        width={994}
        visible={showTemplateModal}
        onCancel={closeTemplateModal}
      >
        <div className={style.template_list}>
          {list.map((item, index) => (
            <Flex
              key={index}
              className={cls(style.template_item, style.modal_template_item)}
              d="v"
              onClick={() => {
                handleCreateActivity(
                  item.id == TEMPLATE_BLANK ? undefined : item
                )
              }}
            >
              {item.id != TEMPLATE_BLANK && (
                <div className={style.preview} onClick={this.preview(item.id)}>
                  <img
                    src="https://qnm.hunliji.com/Fq4fRmSJ7nEBL4RynHnvWyNWIlbO"
                    width={14}
                    height={14}
                  />
                  <span style={{ marginLeft: 3 }}>预览</span>
                </div>
              )}
              <img
                className={cls(
                  style.template_cover,
                  style.modal_template_cover
                )}
                src={item.coverPath}
              />
              <Flex className={style.template_info} hc vc>
                <div className={cls(style.title, style.modal_template_title)}>
                  {item.name}
                </div>
                <Button type="primary" className={style.selectBtn}>
                  选择此模板
                </Button>
              </Flex>
            </Flex>
          ))}
        </div>
      </Modal>
    )
  }
}
